<div class="contract-settings">
  <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>
  <ng-container *ngIf="!loadError">
    <!-- ── VISUALIZZA (riepilogo per sezioni) ── -->
    <div *ngIf="!modifyContract">
      <!-- Header con azioni -->
      <div class="contract-header" *ngIf="!eventId">
        <div>
          <h2 class="contract-title">{{ "profile.tabs.contract" | translate }}</h2>
          <p class="contract-subtitle" *ngIf="contractIsEmpty">
            {{ "profile.contract_empty_msg" | translate }}
          </p>
        </div>
        <div class="contract-header-actions">
          <button class="btn-gold" (click)="openWizard()">
            {{
              contractIsEmpty ? ("profile.configure_wizard_btn" | translate) : ("profile.guided_wizard_btn" | translate)
            }}
          </button>
          <button
            class="btn-outline"
            (click)="openFreeEdit()"
            *ngIf="!contractIsEmpty"
          >
            {{ "profile.free_edit_btn" | translate }}
          </button>
        </div>
      </div>

      <!-- Mostra totale nel contratto (solo contesto profilo) -->
      <div class="show-total-toggle" *ngIf="!eventId">
        <div class="toggle-info">
          <span class="toggle-icon"><app-icon name="calculator" [size]="18" /></span>
          <div>
            <span class="toggle-title">{{ "profile.show_total_contract" | translate }}</span>
            <span class="toggle-sub">
              {{ (show_total ? "profile.total_shown" : "profile.total_hidden") | translate }}
            </span>
          </div>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="show_total" (change)="saveShowTotal()" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Contratto di default già configurato (solo contesto profilo) -->
      <div class="inherited-banner" *ngIf="!contractIsEmpty && !eventId">
        <span class="inherited-icon">✦</span>
        <div>
          <strong>{{ "profile.default_contract_title" | translate }}</strong>
          <p>{{ "profile.default_contract_desc" | translate }}</p>
        </div>
      </div>

      <!-- Se vuoto, mostra banner (solo contesto profilo) -->
      <div class="contract-empty-banner" *ngIf="contractIsEmpty && !eventId">
        <div class="empty-icon"><app-icon name="file" [size]="32" /></div>
        <h3>{{ "profile.configure_title" | translate }}</h3>
        <p>{{ "profile.configure_desc" | translate }}</p>
        <button class="btn-gold" (click)="openWizard()">
          {{ "profile.start_config_btn" | translate }}
        </button>
      </div>

      <!-- Banner "dati dal profilo" (solo contesto evento) -->
      <div class="inherited-banner" *ngIf="eventId && !overrideActive && !readOnly">
        <span class="inherited-icon">✦</span>
        <div>
          <strong>{{ "riepilogo.text_from_profile" | translate }}</strong>
          <p>{{ "riepilogo.text_from_profile_desc" | translate }}</p>
        </div>
      </div>
      <div class="contract-header-actions" *ngIf="eventId && overrideActive && !readOnly">
        <button class="btn-outline" (click)="resetOverride()">
          {{ "riepilogo.restore_from_profile" | translate }}
        </button>
      </div>

      <!-- Sezioni riepilogo -->
      <div *ngIf="!contractIsEmpty || eventId">
        <!-- DATI STUDIO -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="bank" [size]="16" /></span>
              <span class="section-label">{{ "profile.studio_data" | translate }}</span>
            </div>
            <button class="btn-edit-section" *ngIf="!readOnly" (click)="openSection('studio')">
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div *ngIf="!sectionEditState['studio']" class="section-preview">
            <img *ngIf="logoPreview && !eventId" [src]="logoPreview" class="logo-preview" [alt]="'profile.logo.label' | translate" />
            <p>
              <strong>{{ user?.contract?.business_name || "—" }}</strong>
            </p>
            <p class="text-mid">{{ user?.contract?.full_name }}</p>
            <p class="text-light">
              {{ user?.contract?.address }} · {{ user?.contract?.telephone }}
            </p>
            <p class="text-light">
              {{ user?.contract?.email }} · P.IVA {{ user?.contract?.piva }}
            </p>
          </div>
          <div
            *ngIf="sectionEditState['studio']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="logo-field" *ngIf="!eventId">
              <label>{{ "profile.logo.label" | translate }}</label>
              <img *ngIf="logoPreview" [src]="logoPreview" class="logo-preview" [alt]="'profile.logo.label' | translate" />
              <p class="text-light" *ngIf="!logoPreview">{{ "profile.logo.empty" | translate }}</p>
              <div class="logo-actions">
                <button type="button" class="btn-cancel" (click)="logoInput.click()">
                  {{ (logoPreview ? "profile.logo.change" : "profile.logo.upload") | translate }}
                </button>
                <button type="button" class="btn-delete-service" *ngIf="logoPreview" (click)="removeLogo()">
                  {{ "profile.logo.remove" | translate }}
                </button>
                <input #logoInput type="file" accept="image/*" hidden (change)="onLogoSelected($event)" />
              </div>
              <small class="text-light">{{ "profile.logo.hint" | translate }}</small>
            </div>
            <div class="info-box">
              <div class="info">
                <label>{{ "profile.studio_name_label" | translate }}</label>
                <input
                  type="text"
                  formControlName="business_name"
                  [placeholder]="'profile.studio_name_label' | translate"
                />
              </div>
              <div class="info">
                <label>{{ "profile.full_name_label" | translate }}</label>
                <input
                  type="text"
                  formControlName="full_name"
                  [placeholder]="'profile.full_name_label' | translate"
                />
              </div>
            </div>
            <div class="info-box">
              <div class="info">
                <label>{{ "profile.address_label" | translate }}</label>
                <input type="text" formControlName="address" />
              </div>
              <div class="info">
                <label>{{ "profile.phone_label" | translate }}</label>
                <app-phone-input formControlName="telephone"></app-phone-input>
              </div>
            </div>
            <div class="info-box">
              <div class="info">
                <label>{{ "profile.fields.email" | translate }}</label>
                <input type="email" formControlName="email" autocapitalize="off" />
              </div>
              <div class="info">
                <label>{{ "profile.piva_label" | translate }}</label>
                <input type="text" formControlName="piva" />
              </div>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('studio')">
                {{ "profile.save" | translate }}
              </button>
              <button class="btn-cancel" (click)="closeSection('studio')">
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- PAGAMENTO -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="euro" [size]="16" /></span>
              <span class="section-label">{{ "profile.payment_section" | translate }}</span>
            </div>
            <button class="btn-edit-section" *ngIf="!readOnly" (click)="openSection('pagamento')">
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div *ngIf="!sectionEditState['pagamento']" class="section-preview">
            <p class="clause-preview">{{ paymentPreview }}</p>
            <p class="text-light">
              {{ "profile.travel_rate_label" | translate }}: €
              {{ user?.contract?.travel_rate_per_km || 0 }}/km
            </p>
          </div>
          <div
            *ngIf="sectionEditState['pagamento']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="smart-field">
              <label>{{ "profile.deposit_amount_label" | translate }}</label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_type !== 'percent'"
                  (click)="contractForm.patchValue({ deposit_type: 'fixed' })"
                >€ {{ "deposit_toggle.fixed" | translate }}</label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_type === 'percent'"
                  (click)="contractForm.patchValue({ deposit_type: 'percent' })"
                >% {{ "deposit_toggle.percent" | translate }}</label>
              </div>
              <input
                type="number"
                formControlName="deposit_amount"
                min="0"
                [max]="contractForm.value.deposit_type === 'percent' ? 100 : null"
              />
            </div>
            <div class="smart-field">
              <label>{{ "profile.deposit_method_q" | translate }}</label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_method === 'cash'"
                  (click)="contractForm.patchValue({ deposit_method: 'cash' })"
                >
                  {{ "profile.cash" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_method === 'transfer'"
                  (click)="contractForm.patchValue({ deposit_method: 'transfer' })"
                >
                  {{ "profile.transfer" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_method === 'both'"
                  (click)="contractForm.patchValue({ deposit_method: 'both' })"
                >
                  {{ "profile.both" | translate }}
                </label>
              </div>
            </div>
            <div class="smart-field">
              <label>{{ "profile.final_when_q" | translate }}</label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.final_payment_when === 'wedding_day'"
                  (click)="contractForm.patchValue({ final_payment_when: 'wedding_day' })"
                >
                  {{ "profile.wedding_day_opt" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.final_payment_when === 'days_before'"
                  (click)="contractForm.patchValue({ final_payment_when: 'days_before' })"
                >
                  {{ "profile.days_before_opt" | translate }}
                </label>
              </div>
            </div>
            <div
              class="smart-field"
              *ngIf="contractForm.value.final_payment_when === 'days_before'"
            >
              <label>{{ "profile.how_many_days_label" | translate }}</label>
              <input type="number" formControlName="final_payment_days" min="1" />
            </div>
            <div class="smart-field">
              <label>{{ "profile.final_method_q" | translate }}</label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.final_payment_method === 'cash'"
                  (click)="contractForm.patchValue({ final_payment_method: 'cash' })"
                >
                  {{ "profile.cash" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.final_payment_method === 'transfer'"
                  (click)="contractForm.patchValue({ final_payment_method: 'transfer' })"
                >
                  {{ "profile.transfer" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.final_payment_method === 'both'"
                  (click)="contractForm.patchValue({ final_payment_method: 'both' })"
                >
                  {{ "profile.both" | translate }}
                </label>
              </div>
            </div>
            <!-- IBAN (solo se bonifico o entrambi) -->
            <div
              class="smart-field"
              *ngIf="contractForm.value.final_payment_method === 'transfer' || contractForm.value.final_payment_method === 'both'"
            >
              <label>{{ "profile.iban_label" | translate }}</label>
              <input
                type="text"
                formControlName="iban"
                [placeholder]="'profile.iban_placeholder' | translate"
              />
            </div>
            <!-- Tariffa trasferta -->
            <div class="smart-field">
              <label>{{ "profile.travel_rate_label" | translate }}</label>
              <div class="euro-input">
                <span class="euro-prefix">€</span>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="no-spin"
                  formControlName="travel_rate_per_km"
                />
                <span class="euro-suffix">/km</span>
              </div>
              <span class="section-hint">{{ "profile.travel_rate_hint" | translate }}</span>
            </div>
            <!-- Preview live -->
            <div class="live-preview">
              <span class="preview-label">{{ "profile.preview_clause" | translate }}</span>
              <p>{{ paymentPreview }}</p>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('pagamento')">
                {{ "profile.save" | translate }}
              </button>
              <button class="btn-cancel" (click)="closeSection('pagamento')">
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- LOCATION -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="pin" [size]="16" /></span>
              <span class="section-label">{{ "profile.location_reqs" | translate }}</span>
            </div>
            <button class="btn-edit-section" *ngIf="!readOnly" (click)="openSection('location')">
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div *ngIf="!sectionEditState['location']" class="section-preview">
            <p class="clause-preview">{{ locationPreview }}</p>
          </div>
          <div
            *ngIf="sectionEditState['location']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="toggle-group">
              <label class="toggle-item">
                <input type="checkbox" formControlName="needs_table" />
                <span>{{ "profile.work_table" | translate }}</span>
              </label>
              <label class="toggle-item">
                <input type="checkbox" formControlName="needs_natural_light" />
                <span>{{ "profile.natural_light" | translate }}</span>
              </label>
              <label class="toggle-item">
                <input type="checkbox" formControlName="needs_power_outlet" />
                <span>{{ "profile.power_outlet" | translate }}</span>
              </label>
            </div>
            <div class="smart-field note-field">
              <label>{{ "profile.additional_notes_label" | translate }}</label>
              <textarea
                formControlName="location_notes"
                [placeholder]="'profile.location_access_placeholder' | translate"
              ></textarea>
            </div>
            <div class="live-preview">
              <span class="preview-label">{{ "profile.preview_clause" | translate }}</span>
              <p>{{ locationPreview }}</p>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('location')">
                {{ "profile.save" | translate }}
              </button>
              <button class="btn-cancel" (click)="closeSection('location')">
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- CANCELLAZIONE -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="x-circle" [size]="16" /></span>
              <span class="section-label">{{ "profile.cancellation_section" | translate }}</span>
            </div>
            <button
              class="btn-edit-section"
              *ngIf="!readOnly"
              (click)="openSection('cancellazione')"
            >
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div
            *ngIf="!sectionEditState['cancellazione']"
            class="section-preview"
          >
            <p class="clause-preview">{{ cancellationPreview }}</p>
          </div>
          <div
            *ngIf="sectionEditState['cancellazione']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="smart-field">
              <label>{{ "profile.deposit_refundable_q" | translate }} <app-info-tooltip [text]="'profile.deposit_refundable_tooltip' | translate"></app-info-tooltip></label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_refundable === true"
                  (click)="contractForm.patchValue({ deposit_refundable: true })"
                >
                  {{ "profile.yes_refundable" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.deposit_refundable === false"
                  (click)="contractForm.patchValue({ deposit_refundable: false })"
                >
                  {{ "profile.no_refundable" | translate }}
                </label>
              </div>
            </div>
            <div class="smart-field">
              <label>{{ "profile.postponement_q" | translate }} <app-info-tooltip [text]="'profile.postponement_tooltip' | translate"></app-info-tooltip></label>
              <div class="option-group">
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.postponement_policy === 'transfer_date'"
                  (click)="contractForm.patchValue({ postponement_policy: 'transfer_date' })"
                >
                  {{ "profile.transfer_date_opt" | translate }}
                </label>
                <label
                  class="option-card"
                  [class.selected]="contractForm.value.postponement_policy === 'keep_deposit'"
                  (click)="contractForm.patchValue({ postponement_policy: 'keep_deposit' })"
                >
                  {{ "profile.keep_deposit_opt" | translate }}
                </label>
              </div>
            </div>
            <div class="smart-field note-field">
              <label>{{ "profile.additional_notes_label" | translate }}</label>
              <textarea
                formControlName="cancellation_notes"
                [placeholder]="'profile.location_access_placeholder' | translate"
              ></textarea>
            </div>
            <div class="live-preview">
              <span class="preview-label">{{ "profile.preview_clause" | translate }}</span>
              <p>{{ cancellationPreview }}</p>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('cancellazione')">
                {{ "profile.save" | translate }}
              </button>
              <button
                class="btn-cancel"
                (click)="closeSection('cancellazione')"
              >
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- TEMPLATE & FIRMA -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="palette" [size]="16" /></span>
              <span class="section-label">{{ "profile.template_firma" | translate }}</span>
            </div>
            <button class="btn-edit-section" *ngIf="!readOnly" (click)="openSection('firma')">
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div *ngIf="!sectionEditState['firma']" class="section-preview">
            <p>
              {{ "profile.Template" | translate }}:
              <strong>{{ contractForm.value.template || "Default" }}</strong>
            </p>
            <img
              *ngIf="signaturePreview && !eventId"
              [src]="signaturePreview"
              class="signature-preview"
              [alt]="'profile.contract.signature' | translate"
            />
            <p *ngIf="!signaturePreview && !eventId" class="text-light">
              {{ "profile.no_signature" | translate }}
            </p>
          </div>
          <div
            *ngIf="sectionEditState['firma']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="smart-field">
              <label>{{ "profile.template_pdf_label" | translate }}</label>
              <div class="template-grid">
                <div
                  *ngFor="let t of templates"
                  class="template-card"
                  [attr.data-id]="t.id"
                  [class.selected]="contractForm.get('template')?.value === t.id"
                  [class.locked]="t.id !== 'default' && !canProThemes"
                  (click)="selectTemplate(t.id)"
                >
                  <span class="template-name">
                    {{ t.label }}
                    <span *ngIf="t.id !== 'default' && !canProThemes" class="pro-lock"><app-icon name="lock" [size]="12" /></span>
                  </span>
                  <span class="template-desc">{{ t.desc }}</span>
                </div>
              </div>
              <button type="button" class="btn-preview-template" (click)="anteprimaTemplate()">
                <app-icon name="eye" [size]="15" /> {{ "profile.preview_template" | translate }}
              </button>
            </div>
            <div class="smart-field" *ngIf="!eventId">
              <label>{{ "profile.contract.signature" | translate }}</label>
              <img
                *ngIf="signaturePreview"
                [src]="signaturePreview"
                class="signature-preview"
                [alt]="'profile.contract.signature' | translate"
              />
              <p class="canvas-label" *ngIf="signaturePreview">
                {{ "profile.redraw_signature" | translate }}
              </p>
              <app-signature-pad></app-signature-pad>
              <div class="signature-actions">
                <button
                  type="button"
                  class="btn-outline"
                  (click)="clearSignature()"
                >
                  {{ "profile.clear_signature" | translate }}
                </button>
                <button
                  type="button"
                  class="btn-gold"
                  (click)="saveSignature()"
                >
                  {{ "profile.save_signature_btn" | translate }}
                </button>
              </div>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('firma')">
                {{ "profile.save" | translate }}
              </button>
              <button class="btn-cancel" (click)="closeSection('firma')">
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- ── ALTRO (titolo + testo libero) ── -->
        <div class="contract-section">
          <div class="section-header">
            <div>
              <span class="section-icon"><app-icon name="note" [size]="16" /></span>
              <span class="section-label"
                >{{ "profile.other_section" | translate }}
                <app-info-tooltip [text]="'profile.other_section_tooltip' | translate"></app-info-tooltip
              ></span>
            </div>
            <button class="btn-edit-section" *ngIf="!readOnly" (click)="openSection('altro')">
              {{ "profile.edit_btn" | translate }}
            </button>
          </div>
          <div *ngIf="!sectionEditState['altro']" class="section-preview">
            <p *ngIf="user?.contract?.altro?.title">
              <strong>{{ user?.contract?.altro?.title }}</strong>
            </p>
            <p class="clause-preview">{{ user?.contract?.altro?.text || "—" }}</p>
          </div>
          <div
            *ngIf="sectionEditState['altro']"
            class="section-edit"
            [formGroup]="contractForm"
          >
            <div class="smart-field">
              <label>{{ "profile.other_title_label" | translate }}</label>
              <input
                type="text"
                formControlName="altro_title"
                [placeholder]="'profile.other_title_placeholder' | translate"
              />
            </div>
            <div class="smart-field">
              <label>{{ "profile.other_text_label" | translate }}</label>
              <textarea formControlName="altro_text" rows="5"></textarea>
            </div>
            <div class="section-actions">
              <button class="btn-gold" (click)="saveSection('altro')">
                {{ "profile.save" | translate }}
              </button>
              <button class="btn-cancel" (click)="closeSection('altro')">
                {{ "profile.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── WIZARD INTRO ── -->
    <div *ngIf="modifyContract && isWizardMode && wizardIntro" class="wizard-container">
      <div class="wizard-card wizard-intro-card">
        <p class="wizard-chain-step" *ngIf="onboardingChain">{{ "profile.chain_step" | translate: { n: 4 } }}</p>
        <h3 class="wizard-title">{{ "profile.wizard_intro_title" | translate }}</h3>
        <p class="wizard-subtitle">{{ "profile.wizard_intro_p1" | translate }}</p>
        <p class="wizard-subtitle">{{ "profile.wizard_intro_p2" | translate }}</p>
        <div class="wizard-nav">
          <button type="button" class="btn-cancel" (click)="modifyContract = false; isWizardMode = false; wizardIntro = false">
            {{ "profile.wizard_cancel" | translate }}
          </button>
          <button type="button" class="btn-next" (click)="wizardIntro = false">
            {{ "profile.wizard_intro_start" | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── WIZARD ── -->
    <div *ngIf="modifyContract && isWizardMode && !wizardIntro" class="wizard-container">
      <div class="wizard-progress">
        <div class="progress-bar">
          <div
            class="progress-fill"
            [style.width.%]="(contractStep / 4) * 100"
          ></div>
        </div>
        <div class="progress-steps">
          <span
            *ngFor="let s of ['Studio', 'Pagamento', 'Location', 'Cancellazione', 'Template']; let i = index"
            class="progress-step"
            [class.active]="contractStep === i"
            [class.done]="contractStep > i"
          >
            {{ i + 1 }}
          </span>
        </div>
      </div>

      <div class="wizard-card" [formGroup]="contractForm">
        <!-- Step 0: Dati Studio -->
        <div *ngIf="contractStep === 0">
          <h3 class="wizard-title">{{ "profile.wizard_step0_title" | translate }}</h3>
          <p class="wizard-subtitle">{{ "profile.wizard_step0_subtitle" | translate }}</p>
          <div class="info-box">
            <div class="info">
              <label>{{ "profile.studio_name_label" | translate }} *</label>
              <input
                type="text"
                formControlName="business_name"
                [placeholder]="'profile.studio_name_label' | translate"
              />
            </div>
            <div class="info">
              <label>{{ "profile.full_name_label" | translate }} *</label>
              <input
                type="text"
                formControlName="full_name"
                [placeholder]="'profile.full_name_label' | translate"
              />
            </div>
          </div>
          <div class="info-box">
            <div class="info">
              <label>{{ "profile.address_label" | translate }}</label>
              <input type="text" formControlName="address" />
            </div>
            <div class="info">
              <label>{{ "profile.phone_label" | translate }}</label>
              <app-phone-input formControlName="telephone"></app-phone-input>
            </div>
          </div>
          <div class="info-box">
            <div class="info">
              <label>{{ "profile.fields.email" | translate }}</label>
              <input type="email" formControlName="email" autocapitalize="off" />
            </div>
            <div class="info">
              <label>{{ "profile.piva_label" | translate }}</label>
              <input type="text" formControlName="piva" />
            </div>
          </div>
        </div>

        <!-- Step 1: Pagamento -->
        <div *ngIf="contractStep === 1">
          <h3 class="wizard-title">{{ "profile.wizard_step1_title" | translate }}</h3>
          <p class="wizard-subtitle">{{ "profile.wizard_step1_subtitle" | translate }}</p>
          <div class="smart-field">
            <label>{{ "profile.deposit_amount_label" | translate }}</label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_type !== 'percent'"
                (click)="contractForm.patchValue({ deposit_type: 'fixed' })"
              >€ {{ "deposit_toggle.fixed" | translate }}</label>
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_type === 'percent'"
                (click)="contractForm.patchValue({ deposit_type: 'percent' })"
              >% {{ "deposit_toggle.percent" | translate }}</label>
            </div>
            <input
              type="number"
              formControlName="deposit_amount"
              min="0"
              [max]="contractForm.value.deposit_type === 'percent' ? 100 : null"
              placeholder="100"
            />
          </div>
          <div class="smart-field">
            <label>{{ "profile.deposit_method_q" | translate }}</label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_method === 'cash'"
                (click)="contractForm.patchValue({ deposit_method: 'cash' })"
                >{{ "profile.cash" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_method === 'transfer'"
                (click)="contractForm.patchValue({ deposit_method: 'transfer' })"
                >{{ "profile.transfer" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_method === 'both'"
                (click)="contractForm.patchValue({ deposit_method: 'both' })"
                >{{ "profile.both" | translate }}</label
              >
            </div>
          </div>
          <div class="smart-field">
            <label>{{ "profile.final_when_q" | translate }}</label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.final_payment_when === 'wedding_day'"
                (click)="contractForm.patchValue({ final_payment_when: 'wedding_day' })"
                >{{ "profile.wedding_day_opt" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.final_payment_when === 'days_before'"
                (click)="contractForm.patchValue({ final_payment_when: 'days_before' })"
                >{{ "profile.days_before_opt" | translate }}</label
              >
            </div>
          </div>
          <div
            class="smart-field"
            *ngIf="contractForm.value.final_payment_when === 'days_before'"
          >
            <label>{{ "profile.how_many_days_label" | translate }}</label>
            <input type="number" formControlName="final_payment_days" min="1" />
          </div>
          <div class="smart-field">
            <label>{{ "profile.final_method_q" | translate }}</label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.final_payment_method === 'cash'"
                (click)="contractForm.patchValue({ final_payment_method: 'cash' })"
                >{{ "profile.cash" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.final_payment_method === 'transfer'"
                (click)="contractForm.patchValue({ final_payment_method: 'transfer' })"
                >{{ "profile.transfer" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.final_payment_method === 'both'"
                (click)="contractForm.patchValue({ final_payment_method: 'both' })"
                >{{ "profile.both" | translate }}</label
              >
            </div>
          </div>
          <div class="smart-field">
            <label>{{ "profile.travel_rate_label" | translate }}</label>
            <div class="euro-input">
              <span class="euro-prefix">€</span>
              <input
                type="number"
                min="0"
                step="0.01"
                class="no-spin"
                formControlName="travel_rate_per_km"
              />
              <span class="euro-suffix">/km</span>
            </div>
            <span class="section-hint">{{ "profile.travel_rate_hint" | translate }}</span>
          </div>
          <div class="live-preview">
            <span class="preview-label">{{ "profile.preview_generated" | translate }}</span>
            <p>{{ paymentPreview }}</p>
          </div>
        </div>

        <!-- Step 2: Location -->
        <div *ngIf="contractStep === 2">
          <h3 class="wizard-title">{{ "profile.wizard_step2_title" | translate }}</h3>
          <p class="wizard-subtitle">{{ "profile.wizard_step2_subtitle" | translate }}</p>
          <div class="toggle-group">
            <label class="toggle-item">
              <input type="checkbox" formControlName="needs_table" />
              <span>{{ "profile.work_table_full" | translate }}</span>
            </label>
            <label class="toggle-item">
              <input type="checkbox" formControlName="needs_natural_light" />
              <span>{{ "profile.natural_light_full" | translate }}</span>
            </label>
            <label class="toggle-item">
              <input type="checkbox" formControlName="needs_power_outlet" />
              <span>{{ "profile.power_outlet_full" | translate }}</span>
            </label>
          </div>
          <div class="smart-field" style="margin-top: 1rem">
            <label>{{ "profile.other_needs" | translate }}</label>
            <textarea
              formControlName="location_notes"
              [placeholder]="'profile.location_access_placeholder' | translate"
            ></textarea>
          </div>
          <div class="live-preview">
            <span class="preview-label">{{ "profile.preview_generated" | translate }}</span>
            <p>{{ locationPreview }}</p>
          </div>
        </div>

        <!-- Step 3: Cancellazione -->
        <div *ngIf="contractStep === 3">
          <h3 class="wizard-title">{{ "profile.wizard_step3_title" | translate }}</h3>
          <p class="wizard-subtitle">{{ "profile.wizard_step3_subtitle" | translate }}</p>
          <div class="smart-field">
            <label>{{ "profile.deposit_refundable_short" | translate }} <app-info-tooltip [text]="'profile.deposit_refundable_tooltip' | translate"></app-info-tooltip></label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_refundable === true"
                (click)="contractForm.patchValue({ deposit_refundable: true })"
                >{{ "profile.yes_refundable" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.deposit_refundable === false"
                (click)="contractForm.patchValue({ deposit_refundable: false })"
                >{{ "profile.no_refundable" | translate }}</label
              >
            </div>
          </div>
          <div class="smart-field">
            <label>{{ "profile.postponement_q" | translate }} <app-info-tooltip [text]="'profile.postponement_tooltip' | translate"></app-info-tooltip></label>
            <div class="option-group">
              <label
                class="option-card"
                [class.selected]="contractForm.value.postponement_policy === 'transfer_date'"
                (click)="contractForm.patchValue({ postponement_policy: 'transfer_date' })"
                >{{ "profile.transfer_date_opt" | translate }}</label
              >
              <label
                class="option-card"
                [class.selected]="contractForm.value.postponement_policy === 'keep_deposit'"
                (click)="contractForm.patchValue({ postponement_policy: 'keep_deposit' })"
                >{{ "profile.keep_deposit_opt" | translate }}</label
              >
            </div>
          </div>
          <div class="smart-field">
            <label>{{ "profile.additional_notes_label" | translate }}</label>
            <textarea
              formControlName="cancellation_notes"
              [placeholder]="'profile.location_access_placeholder' | translate"
            ></textarea>
          </div>
          <div class="live-preview">
            <span class="preview-label">{{ "profile.preview_generated" | translate }}</span>
            <p>{{ cancellationPreview }}</p>
          </div>
        </div>

        <!-- Step 4: Template & Firma -->
        <div *ngIf="contractStep === 4">
          <h3 class="wizard-title">{{ "profile.wizard_step4_title" | translate }}</h3>
          <p class="wizard-subtitle">{{ "profile.wizard_step4_subtitle" | translate }}</p>
          <div class="template-grid">
            <div
              *ngFor="let t of templates"
              class="template-card"
              [attr.data-id]="t.id"
              [class.selected]="contractForm.get('template')?.value === t.id"
              (click)="contractForm.patchValue({ template: t.id })"
            >
              <span class="template-name">{{ t.label }}</span>
              <span class="template-desc">{{ t.desc }}</span>
            </div>
          </div>
          <button type="button" class="btn-preview-template" (click)="anteprimaTemplate()">
            <app-icon name="eye" [size]="15" /> {{ "profile.preview_template" | translate }}
          </button>
          <div class="smart-field" style="margin-top: 1.5rem">
            <label>{{ "profile.contract.signature" | translate }}</label>
            <img
              *ngIf="signaturePreview"
              [src]="signaturePreview"
              class="signature-preview"
              [alt]="'profile.contract.signature' | translate"
            />
            <app-signature-pad></app-signature-pad>
            <div class="signature-actions">
              <button
                type="button"
                class="btn-outline"
                (click)="clearSignature()"
              >
                {{ "profile.clear_signature" | translate }}
              </button>
              <button type="button" class="btn-gold" (click)="saveSignature()">
                {{ "profile.save_signature_btn" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigazione wizard -->
      <div class="wizard-nav">
        <button
          class="btn-cancel"
          (click)="prevStep()"
          *ngIf="contractStep > 0"
        >
          {{ "profile.wizard_prev" | translate }}
        </button>
        <button
          class="btn-cancel"
          (click)="modifyContract = false; isWizardMode = false"
          *ngIf="contractStep === 0"
        >
          {{ "profile.wizard_cancel" | translate }}
        </button>
        <button
          class="btn-gold"
          (click)="nextStep()"
          *ngIf="contractStep < 4"
        >
          {{ "profile.wizard_next" | translate }}
        </button>
        <button
          class="btn-gold"
          (click)="saveContract()"
          *ngIf="contractStep === 4"
        >
          {{ "profile.wizard_save" | translate }}
        </button>
      </div>
    </div>

    <!-- ── MODIFICA LIBERA ── -->
    <div
      *ngIf="modifyContract && !isWizardMode"
      class="profile-card"
      [formGroup]="contractForm"
    >
      <div class="free-edit-header">
        <h2 class="title">{{ "profile.free_edit_title" | translate }}</h2>
        <button class="btn-cancel" (click)="modifyContract = false">✕</button>
      </div>

      <div class="section-divider"><span>{{ "profile.studio_data" | translate }}</span></div>
      <div class="info-box">
        <div class="info">
          <label>{{ "profile.studio_name_short" | translate }}</label>
          <input type="text" formControlName="business_name" />
        </div>
        <div class="info">
          <label>{{ "profile.full_name_label" | translate }}</label>
          <input type="text" formControlName="full_name" />
        </div>
        <div class="info">
          <label>{{ "profile.address_label" | translate }}</label>
          <input type="text" formControlName="address" />
        </div>
        <div class="info">
          <label>{{ "profile.phone_label" | translate }}</label>
          <app-phone-input formControlName="telephone"></app-phone-input>
        </div>
        <div class="info">
          <label>{{ "profile.fields.email" | translate }}</label>
          <input type="email" formControlName="email" autocapitalize="off" />
        </div>
        <div class="info">
          <label>{{ "profile.piva_label" | translate }}</label>
          <input type="text" formControlName="piva" />
        </div>
      </div>

      <div class="section-divider"><span>{{ "profile.payment_section" | translate }}</span></div>
      <div class="smart-field">
        <label>{{ "profile.deposit_amount_label" | translate }}</label>
        <div class="option-group">
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_type !== 'percent'"
            (click)="contractForm.patchValue({ deposit_type: 'fixed' })"
          >€ {{ "deposit_toggle.fixed" | translate }}</label>
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_type === 'percent'"
            (click)="contractForm.patchValue({ deposit_type: 'percent' })"
          >% {{ "deposit_toggle.percent" | translate }}</label>
        </div>
        <input
          type="number"
          formControlName="deposit_amount"
          min="0"
          [max]="contractForm.value.deposit_type === 'percent' ? 100 : null"
        />
      </div>
      <div class="smart-field">
        <label>{{ "profile.deposit_method_label" | translate }}</label>
        <div class="option-group">
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_method === 'cash'"
            (click)="contractForm.patchValue({ deposit_method: 'cash' })"
            >{{ "profile.cash" | translate }}</label
          >
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_method === 'transfer'"
            (click)="contractForm.patchValue({ deposit_method: 'transfer' })"
            >{{ "profile.transfer" | translate }}</label
          >
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_method === 'both'"
            (click)="contractForm.patchValue({ deposit_method: 'both' })"
            >{{ "profile.both" | translate }}</label
          >
        </div>
      </div>
      <div class="smart-field">
        <label>{{ "profile.final_when_q" | translate }}</label>
        <div class="option-group">
          <label
            class="option-card"
            [class.selected]="contractForm.value.final_payment_when === 'wedding_day'"
            (click)="contractForm.patchValue({ final_payment_when: 'wedding_day' })"
            >{{ "profile.wedding_day_short" | translate }}</label
          >
          <label
            class="option-card"
            [class.selected]="contractForm.value.final_payment_when === 'days_before'"
            (click)="contractForm.patchValue({ final_payment_when: 'days_before' })"
            >{{ "profile.days_before_opt" | translate }}</label
          >
        </div>
      </div>
      <div
        class="smart-field"
        *ngIf="contractForm.value.final_payment_when === 'days_before'"
      >
        <label>{{ "profile.how_many_days_label" | translate }}</label>
        <input type="number" formControlName="final_payment_days" min="1" />
      </div>
      <div class="live-preview">
        <span class="preview-label">{{ "profile.preview_payment" | translate }}</span>
        <p>{{ paymentPreview }}</p>
      </div>

      <div class="section-divider"><span>{{ "profile.location_reqs" | translate }}</span></div>
      <div class="toggle-group">
        <label class="toggle-item"
          ><input type="checkbox" formControlName="needs_table" /><span
            >{{ "profile.work_table_full" | translate }}</span
          ></label
        >
        <label class="toggle-item"
          ><input type="checkbox" formControlName="needs_natural_light" /><span
            >{{ "profile.natural_light_full" | translate }}</span
          ></label
        >
        <label class="toggle-item"
          ><input type="checkbox" formControlName="needs_power_outlet" /><span
            >{{ "profile.power_outlet_full" | translate }}</span
          ></label
        >
      </div>
      <div class="smart-field">
        <label>{{ "profile.location_notes_label" | translate }}</label>
        <textarea formControlName="location_notes"></textarea>
      </div>
      <div class="live-preview">
        <span class="preview-label">{{ "profile.preview_location" | translate }}</span>
        <p>{{ locationPreview }}</p>
      </div>

      <div class="section-divider"><span>{{ "profile.cancellation_section" | translate }}</span></div>
      <div class="smart-field">
        <label>{{ "profile.deposit_refundable_short2" | translate }} <app-info-tooltip [text]="'profile.deposit_refundable_tooltip' | translate"></app-info-tooltip></label>
        <div class="option-group">
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_refundable === true"
            (click)="contractForm.patchValue({ deposit_refundable: true })"
            >{{ "profile.yes_short" | translate }}</label
          >
          <label
            class="option-card"
            [class.selected]="contractForm.value.deposit_refundable === false"
            (click)="contractForm.patchValue({ deposit_refundable: false })"
            >{{ "profile.no_short" | translate }}</label
          >
        </div>
      </div>
      <div class="smart-field">
        <label>{{ "profile.postponement_policy_label" | translate }} <app-info-tooltip [text]="'profile.postponement_tooltip' | translate"></app-info-tooltip></label>
        <div class="option-group">
          <label
            class="option-card"
            [class.selected]="contractForm.value.postponement_policy === 'transfer_date'"
            (click)="contractForm.patchValue({ postponement_policy: 'transfer_date' })"
            >{{ "profile.transfer_short" | translate }}</label
          >
          <label
            class="option-card"
            [class.selected]="contractForm.value.postponement_policy === 'keep_deposit'"
            (click)="contractForm.patchValue({ postponement_policy: 'keep_deposit' })"
            >{{ "profile.keep_deposit_short" | translate }}</label
          >
        </div>
      </div>
      <div class="smart-field">
        <label>{{ "profile.cancellation_notes_label" | translate }}</label>
        <textarea formControlName="cancellation_notes"></textarea>
      </div>
      <div class="live-preview">
        <span class="preview-label">{{ "profile.preview_cancellation" | translate }}</span>
        <p>{{ cancellationPreview }}</p>
      </div>

      <div class="section-divider"><span>{{ "profile.template_firma" | translate }}</span></div>
      <div class="template-grid">
        <div
          *ngFor="let t of templates"
          class="template-card"
          [attr.data-id]="t.id"
          [class.selected]="contractForm.get('template')?.value === t.id"
          (click)="contractForm.patchValue({ template: t.id })"
        >
          <span class="template-name">{{ t.label }}</span>
          <span class="template-desc">{{ t.desc }}</span>
        </div>
      </div>
      <button type="button" class="btn-preview-template" (click)="anteprimaTemplate()">
        <app-icon name="eye" [size]="15" /> {{ "profile.preview_template" | translate }}
      </button>
      <div class="smart-field" style="margin-top: 1rem">
        <label>{{ "profile.contract.signature" | translate }}</label>
        <img
          *ngIf="signaturePreview"
          [src]="signaturePreview"
          class="signature-preview"
          [alt]="'profile.contract.signature' | translate"
        />
        <app-signature-pad></app-signature-pad>
        <div class="signature-actions">
          <button type="button" class="btn-outline" (click)="clearSignature()">
            {{ "profile.clear_signature" | translate }}
          </button>
          <button type="button" class="btn-gold" (click)="saveSignature()">
            {{ "profile.save_signature_btn" | translate }}
          </button>
        </div>
      </div>

      <div class="buttons">
        <button type="button" class="btn-gold" (click)="saveContract()">
          {{ "profile.save_all" | translate }}
        </button>
        <button
          type="button"
          class="btn-cancel"
          (click)="modifyContract = false"
        >
          {{ "profile.cancel" | translate }}
        </button>
      </div>
    </div>

  <!-- ANTEPRIMA TEMPLATE CONTRATTO -->
  <div class="preview-overlay" *ngIf="previewOpen" (click)="closePreview()">
    <div class="preview-container" (click)="$event.stopPropagation()">
      <div class="preview-head">
        <h3 class="preview-title">{{ "profile.preview_template_title" | translate }}</h3>
        <button class="preview-close" (click)="closePreview()" aria-label="close">✕</button>
      </div>
      <iframe class="preview-frame" *ngIf="previewUrl" [src]="previewUrl"></iframe>
      <div class="preview-actions">
        <button class="btn-close-preview" (click)="closePreview()">
          {{ "profile.close" | translate }}
        </button>
      </div>
    </div>
  </div>
  </ng-container>
</div>
